module.exports = __webpack_public_path__ + "img/batrider.ad53dc94.png";